module.exports = __webpack_public_path__ + "static/media/street-triple-rs.a409ef83.jpg";